import React from 'react';
import { Body } from '@hover/blueprint';
import { IFaqQuestion } from '../interfaces/IFaqQuestion';

export const ARCHITECTS_FAQ: Array<IFaqQuestion> = [
  {
    id: 0,
    title: 'How does HOVER save architects time?',
    content: (
      <Body mb={500}>
        HOVER eliminates the need to measure and reconstruct properties in
        modeling software.
      </Body>
    ),
  },
  {
    id: 1,
    title: 'How many photos does HOVER need to generate a 3D model?',
    content: (
      <Body mb={500}>
        It varies. HOVER needs several photos of all sides and corners of a home
        to generate a 3D model. The app guides users through the capture process
        so you get the right number of photos for each property.
      </Body>
    ),
  },
  {
    id: 2,
    title: "How accurate are HOVER's 3D models?",
    content: (
      <Body mb={500}>
        HOVER&apos;3D models are accurate within plus or minus 5% to the nearest
        inch.
      </Body>
    ),
  },
  {
    id: 3,
    title: "How can HOVER's 3D models be used by architects?",
    content: (
      <Body mb={500}>
        HOVER&apos;3D models can be used to create drawings and solidify
        construction plans.
      </Body>
    ),
  },
  {
    id: 4,
    title: "Which file types can HOVER's 3D models be exported as?",
    content: (
      <Body mb={500}>
        HOVER&apos;3D models can be exported as SKP, DXF, and DWG file types
      </Body>
    ),
  },
];
